let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hPxS2")).then(() => parcelRequire('atxbj'));